import { InputLabel, MenuItem } from '@mui/material';
import { memo } from 'react';
import { __ACT_API_URL__ } from 'shell/constants/environment';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { HttpResponse } from 'shell/models/http-response';
import { Operation } from 'shell/view-models/operation';
import { ValueDomainType } from 'shell/models/value-domain-type';
import { DomainType } from 'civil-status/constants/domain';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';
import { PmiSelect } from 'shell/components/shared/pmi-select';
import { ItemVM } from 'shell/view-models/item';

interface StatisticListProps {
  disabled?: boolean;
  value?: string;
  onChange: (value: string) => void;
  error?: boolean;
  required?: boolean;
  label?: string;
  id?: string;
}

const StatisticListComponent = ({
  disabled,
  onChange,
  required,
  value: selectedValue,
  error,
  label = 'Codice Statistico',
  id = 'statistic',
}: StatisticListProps): React.ReactElement => {
  const [municipalities] = useHttpFetch<HttpResponse<Array<ValueDomainType>>, Array<ItemVM>>(
    `${__ACT_API_URL__}/valori-dominio-atti?filters=idDominio:${DomainType.Statistic}:${Operation.EQUALS}`,
    {
      onBootstrap: true,
      options: {
        method: 'GET',
        loading: true,
        errorCatching: true,
      },
      transformer: (response) => {
        return response.data.payload.map((el) => ({
          id: el?.key?.idValore || '',
          value: el.valore || '',
        }));
      },
    }
  );

  const data = (municipalities.data as Array<ItemVM>) || [];

  return (
    <PmiFormControl fullWidth>
      <InputLabel error={error} disabled={disabled} id={`${id}-label`}>
        {required ? `${label} *` : `${label}`}
      </InputLabel>
      <PmiSelect
        labelId={`${id}-label`}
        id={id}
        name={id}
        value={selectedValue}
        label={required ? `${label} *` : `${label}`}
        onChange={(event) => {
          onChange(event.target.value);
        }}
        disabled={disabled}
        error={error}
      >
        {data.map((service) => (
          <MenuItem key={service.id} value={service.id}>
            {service.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

StatisticListComponent.displayName = 'Statistic list component';

const StatisticListANSC = memo(StatisticListComponent);

export default StatisticListANSC as typeof StatisticListComponent;
